var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkHorizontalIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_12531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97003 9.42032C3.18003 8.31782 4.21503 7.56031 5.34003 7.56031H7.53753C7.92753 7.56031 8.25003 7.23781 8.25003 6.84781C8.25003 6.45781 7.92753 6.13531 7.53753 6.13531H5.41503C3.45753 6.13531 1.71003 7.56782 1.52253 9.51782C1.30503 11.7528 3.06003 13.6353 5.25003 13.6353H7.53753C7.92753 13.6353 8.25003 13.3128 8.25003 12.9228C8.25003 12.5328 7.92753 12.2103 7.53753 12.2103H5.25003C3.81753 12.2103 2.68503 10.9053 2.97003 9.42032ZM6.75003 10.6353H11.25C11.6625 10.6353 12 10.2978 12 9.88531C12 9.47282 11.6625 9.13531 11.25 9.13531H6.75003C6.33753 9.13531 6.00003 9.47282 6.00003 9.88531C6.00003 10.2978 6.33753 10.6353 6.75003 10.6353ZM12.585 6.13531H10.4625C10.0725 6.13531 9.75003 6.45781 9.75003 6.84781C9.75003 7.23781 10.0725 7.56031 10.4625 7.56031H12.66C13.785 7.56031 14.82 8.31782 15.03 9.42032C15.315 10.9053 14.1825 12.2103 12.75 12.2103H10.4625C10.0725 12.2103 9.75003 12.5328 9.75003 12.9228C9.75003 13.3128 10.0725 13.6353 10.4625 13.6353H12.75C14.94 13.6353 16.695 11.7528 16.485 9.51782C16.2975 7.56782 14.5425 6.13531 12.585 6.13531Z",
    fill: "#123051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_12531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.885315)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHorizontalIcon);
export default __webpack_public_path__ + "static/media/linkHorizontalIcon.b44de5e84af7a6bc1a5876a8d51942f1.svg";
export { ForwardRef as ReactComponent };